import {useEffect} from 'react';
import {useNavigate, useParams} from 'react-router-dom';
import {SoopLoading, SoopSectionTitle} from '@soop-ui/soop-ui';
import {useHelpContext} from '@/app/(main)/routes/help/context/HelpContext';
import {
  useGetFaqBody,
  useGetFaqMainCategoryId,
  useExpandedFaq,
} from '@/hooks/help';
import FaqItem from '@/components/help/common/FaqBoard/FaqItem';
import boardStyles from '@/components/help/pc/common/FaqBoard/FaqBoard.module.scss';
import EmptyBoard from '@/components/help/common/EmptyBoard';
import titleStyles from '../Faq.module.scss';

const HelpFaqDetail = () => {
  const {isMobile} = useHelpContext();
  const navigate = useNavigate();
  const {questionId: questionIdParam} = useParams();
  const questionId = questionIdParam!;
  const {expandedId, setExpandedId} = useExpandedFaq();
  const {data, isLoading} = useGetFaqBody({
    enabled: true,
    questionId,
  });
  const {
    data: mainCategory,
    isSuccess,
    isFetched,
  } = useGetFaqMainCategoryId(data?.subCategory || '');

  useEffect(() => {
    setExpandedId(questionId);
  }, []);

  useEffect(() => {
    if (isFetched && isSuccess) {
      navigate('', {
        state: {
          mainCategory: mainCategory,
          subCategory: data?.subCategory,
        },
        replace: true,
        preventScrollReset: true,
      });
    }
  }, [isFetched, isSuccess, mainCategory, navigate]);

  return (
    <>
      {!isMobile && data?.title && (
        <SoopSectionTitle className={titleStyles.SectionTitle}>
          <SoopSectionTitle.Title size='lg'>Q&A</SoopSectionTitle.Title>
        </SoopSectionTitle>
      )}
      {isLoading ? (
        <SoopLoading isDevice={isMobile ? 'mobile' : 'desktop'} />
      ) : !data?.title ? (
        <EmptyBoard type='faq' />
      ) : (
        <div>
          <div className={boardStyles.FaqListArea}>
            <FaqItem
              item={{
                kbId: questionId,
                title: data?.title || '',
              }}
              isExpanded={expandedId === questionId}
              onExpand={() => setExpandedId(questionId)}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default HelpFaqDetail;
